import moment from "moment";
import { required, requiredIf, email, decimal } from "vuelidate/lib/validators";
import { updateForm } from "@state/modules";
import { isPhone } from "@src/custom-validators";

export const state = {
  form: {
    professional: null,
    First_Name: null,
    Last_Name: null,
    PreferredName: null,
    Day_Telephone: null,
    ConsumerEmail: null,
    DOBText: null,
    RawDOB: null,
    GenderAtBirth: null,
    Gender: [],
    Gender_OtherDetail: null,
    GenderOrientation: null,
    GenderOrientation_OtherDetail: null,
    MaritalStatus: null,
    MonthlyGrossIncome: null,
    Assets: null,
    AddressInfo: null,
    City: null,
    State_Abbr: "PA",
    ZipCode: null,
    RS_FirstName: null,
    RS_LastName: null,
    ReferralSource_Relationship: null,
    ReferralSource_Phone: null,
    ReferralEmail: null,
    ReferralSource_Agency: null,
    RS_MailingAddress: null,
    RS_City: null,
    RS_State: "PA",
    RS_ZipCode: null,
    SendInfoTo: null,
    NotificationEmails:
      "RobertsSD@co.delaware.pa.us, PalmerMR@co.delaware.pa.us, GarrettK@co.delaware.pa.us, Harleyd@co.delaware.pa.us, AchilefuI@co.delaware.pa.us, pasquarellara@co.delaware.pa.us, smitha@co.delaware.pa.us, mason.schaefer@agisnetwork.com, dexie.galvez@agisnetwork.com"
  },
  formatters: [
    {
      DOB: "formattedDOB"
    },
    {
      PDFTitle: "formattedPDFStamp"
    },
    {
      RSName: "formattedRSName"
    }
  ]
};

export const validations = {
  form: {
    professional: {
      required
    },
    First_Name: {
      required
    },
    Last_Name: {
      required
    },
    Day_Telephone: {
      requiredIf: requiredIf(vueInstance => {
        return vueInstance.professional === "yes";
      }),
      phone: isPhone
    },
    ConsumerEmail: {
      email
    },
    DOBText: {
      requiredIf: requiredIf(vueInstance => {
        return vueInstance.professional === "no";
      })
    },
    RawDOB: {
      requiredIf: requiredIf(vueInstance => {
        return vueInstance.professional === "yes";
      })
    },
    GenderAtBirth: {
      requiredIf: requiredIf(vueInstance => {
        return vueInstance.professional === "yes";
      })
    },
    Gender: {
      requiredIf: requiredIf(vueInstance => {
        return vueInstance.professional === "yes";
      })
    },
    Gender_OtherDetail: {
      requiredIf: requiredIf(vueInstance => {
        return vueInstance.Gender && vueInstance.Gender.includes("NotListed");
      })
    },
    GenderOrientation: {
      requiredIf: requiredIf(vueInstance => {
        return vueInstance.professional === "yes";
      })
    },
    GenderOrientation_OtherDetail: {
      requiredIf: requiredIf(vueInstance => {
        return (
          //  vueInstance.GenderOrientation &&
          //  vueInstance.GenderOrientation.includes("NotListed")
          vueInstance.GenderOrientation == "NotListed"
        );
      })
    },
    AddressInfo: {
      required
    },
    City: {
      required
    },
    State_Abbr: {
      required
    },
    ZipCode: {
      required
    },
    MonthlyGrossIncome: {
      decimal
    },
    Assets: {
      decimal
    },
    RS_ZipCode: {
      decimal
    },
    RS_FirstName: {
      required
    },
    RS_LastName: {
      required
    },
    ReferralSource_Phone: {
      required,
      phone: isPhone
    },
    ReferralEmail: {
      email
    },
    ReferralSource_Agency: {
      requiredIf: requiredIf(vueInstance => {
        return vueInstance.professional === "yes";
      })
    }
  }
};

export const getters = {
  formattedDOB: state => {
    //moment(state.form.RawDOB).isSameOrBefore(now);
    if (state.form.professional === "yes") {
      if (!state.form.RawDOB) return "";
      state.form.DOBText == "";
      return moment(state.form.RawDOB).format("L");
    }

    if (state.form.professional === "no") {
      state.form.RawDOB == "";
      return state.form.DOBText;
    }
  },
  /* formattedDOB: state => {
    //moment(state.form.RawDOB).isSameOrBefore(now);
    if (!state.form.RawDOB) return "";
    return moment(state.form.RawDOB).format("L");
  },   */
  /* formattedDOB: state => {
    //moment(state.form.RawDOB).isSameOrBefore(now);
    if (!state.form.DOBText) return "";
    return moment(state.form.DOBText).format("L");
  },   */
  formattedPDFStamp: state => {
    if (state.form.professional === "yes") {
      return "SECTION 1-REFERRAL INFORMATION (THIS REFERRAL FOR PROFESSIONAL USE)";
    }
    return "SECTION 1-REFERRAL INFORMATION";
  },
  formattedRSName: state => {
    return state.form.RS_FirstName + " " + state.form.RS_LastName;
  }
};

export const mutations = {
  updateForm
};

export const actions = {};
